import { css } from '@emotion/react';
import type { ReactNode } from 'react';
import type { LatLng } from '~/_shared/types/latLng';

type ReportMapSummaryProps = Readonly<{
  className?: string;
  latLng: LatLng;
  heading: ReactNode;
  semiHeading?: ReactNode;
  description?: ReactNode;
}>;

const wrapperStyle = css({
  backgroundColor: '#EAF5FB',
  borderColor: '#DFE3E8',
  padding: 4,
  color: '#2C3E50',
  borderRadius: 4,
  boxShadow: '0px 1px 2px 0px #00000014',
});

const latLngStyle = css({
  display: 'flex',
  gap: 10,
  color: '#566976',
  fontSize: 12,
});

const headingStyle = css({
  fontWeight: 600,
  fontSize: 18,
  marginTop: 5,
});

const headingSecondaryStyle = css({
  fontSize: 14,
});

export const ReportMapSummaryComponent = (props: ReportMapSummaryProps) => {
  return (
    <div css={wrapperStyle} className={props.className}>
      <div css={latLngStyle}>
        <span>{`Lat: ${props.latLng.lat}`}</span>
        <span>{`Lng: ${props.latLng.lng}`}</span>
      </div>
      <div css={headingStyle}>{props.heading}</div>
      {props.semiHeading && (
        <div css={headingSecondaryStyle}>{props.semiHeading}</div>
      )}
      {props.description && (
        <div css={headingSecondaryStyle}>{props.description}</div>
      )}
    </div>
  );
};
